var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58621 7.74779L0.515214 1.3135L1.92921 0.0268183L9.70721 7.10445C9.89468 7.27509 10 7.5065 10 7.74779C10 7.98907 9.89468 8.22048 9.70721 8.39112L1.92921 15.4687L0.515214 14.1821L7.58621 7.74779Z",
    fill: "#3D6B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextRightIcon);
export default __webpack_public_path__ + "static/media/next_right_icon.ab81ba5491e0093b891d7ee5a7601d85.svg";
export { ForwardRef as ReactComponent };